import {FeatureConfig} from '@/utils/constants/featuresFlag';

export const BASE_URL_PLACEHOLDER = {
  ADMIN_PORTAL: `{{${FeatureConfig.apiAdminUrl}}}`,
  EVENTS: `{{${FeatureConfig.apiEventsUrl}}}`
};

/**
 * @deprecated Use the new API endpoints defined in the API_CONFIG object.
 */
export const ENDPOINTS = {
  LOAD_POINT_MULTIPLIER: '/api/v1/point-multiplier',
  LOAD_POINT_MULTIPLIER_COL_CONFIG: '/pointMultiplierColumnConfig',
  LOAD_SALES_TARGETS: '/api/v1/sales-targets',
  LOAD_SALES_TARGETS_COL_CONFIG: '/api/v1/sales-targets-column-config',
  LOAD_SALES_TARGETS_ACTIVITIES: '/api/v1/sales-targets-activities',
  LOAD_SALES_TARGETS_ACTIVITIES_COL_CONFIG:
    '/api/v1/sales-targets-activities-column-config',
  LOAD_PREREQUISITE_TARGETS: '/api/v1/pre-requisite-target',
  LOAD_ORDER_ITEM_OVERVIEW: '/api/v1/order-item-overview',
  LOAD_ORDER_ITEM_OVERVIEW_SUB_ITEM_COL_CONFIG:
    '/api/v1/order-item-overview-sub-item-column-config',
  CREATE_SALES_TARGET: '/api/v1/sales-targets',

  // MARK: - Admin-Portal Endpoints
  LOAD_USER_ROLES: `${BASE_URL_PLACEHOLDER.ADMIN_PORTAL}/v1/users/auth/cct`,

  // MARK: - Real-Time Events Endpoints
  LOAD_EVENTS: `${BASE_URL_PLACEHOLDER.EVENTS}/eventnotifications`,
  CREATE_EVENT: `${BASE_URL_PLACEHOLDER.EVENTS}/eventnotifications`,
  LOAD_EVENT: `${BASE_URL_PLACEHOLDER.EVENTS}/eventnotifications/:id`,

  // master tables
  LOAD_COUNTRIES: '/countries',
  LOAD_LANGUAGES: '/languages'
};

export const SALES_TARGETS_QUERY_KEY = 'salesTargets';
export const SALES_TARGETS_ACTIVITIES_QUERY_KEY = 'salesTargetsActivities';
